import { useState } from "react";
import { useDispatch } from "react-redux"
import { generalOpenToastError } from "../../../../actions/general.actions";
import BasicCardDocumentos from "../../../OtrosDocumentos/Components/BasicCardDocumentos";
import InputForm from "../../../OtrosDocumentos/Components/InputFormV2";
import { getHistorialBitacora } from "../../../../actions/bitacora/bitacora.actions";
import { BITACORA_TYPES } from "../../../../constants/bitacora.types";

export const optionsEstadosCorreos = [{codigo_nombre: "Todos", codigo: "-1"}, {codigo_nombre: "Exitoso", codigo: "1"}, {codigo_nombre: "Fallidos", codigo: "2"}];

export default function FormularioFiltroBitacora (){
    const dispatch = useDispatch()
    const defaultValue = {Dte: '', DocCliente: '', Estado: '', Destinatario: ''}
    const [data, setData] = useState({...defaultValue, Estado: '-1'});
    const [errors, setErrors] = useState(defaultValue)

    const onChangeHandler = async (e: any) => {
        let {name, value} = e.target;
        const errorMessage = HandleValidationError(e);
        setData(prevData => ({
          ...prevData,
          [name]: value
        }));
        setErrors(prevData => ({
          ...prevData,
          [name]: errorMessage
        })); 
    }

    const handleOpenWarning = async () => {
        if (!validarVacios()) return;
        dispatch(getHistorialBitacora(data));
    }

    const validarVacios = () => {
        var minFiltro = (data.Dte || data.Destinatario || data.DocCliente || data.Estado !== "-1");
        if (!minFiltro) {
            dispatch(generalOpenToastError('Por favor, especifique al menos un filtro para realizar la búsqueda.'));
            return false;
        }
        return true;
    }

    const HandleValidationError = (e: any) => {
        let {name, value} = e.target
        let message = ''
        switch (name) {
          default:
            break
        }
        return message;
    }

    return (
        <>
            <div className="w-layout-layout bill-section wf-layout-layout">
            <BasicCardDocumentos style={{boxShadow: 'none', padding: '0'}} title="Estado del correo" size="l">
                <div className='w-layout-hflex h-inputs'>
                <InputForm value={data.Dte} error={errors.Dte} onChange={onChangeHandler} maxLength = {60} name = 'Dte' placeholder = 'Número DTE' label = 'DTE' type = 'text' />
                <InputForm value={data.DocCliente} error={errors.DocCliente} onChange={onChangeHandler} maxLength = {60} name = 'DocCliente' placeholder = 'Documento del cliente' label = 'Documento del cliente' type = 'text' />
                <InputForm 
                    value={data.Estado} error={errors.Estado} 
                    onChange = {(e: any) => onChangeHandler({target: {value: e.value, name: 'Estado'}})} 
                    keyNameText = 'codigo_nombre' keyNameValue = 'codigo'
                    name = 'Estado' type = 'select' defaultValue="-1" 
                    placeholder = 'Seleccione un estado' label = 'Estado' 
                    options = {optionsEstadosCorreos} 
                />
                <InputForm value={data.Destinatario} error={errors.Destinatario} onChange={onChangeHandler} maxLength = {60} name = 'Destinatario' placeholder = 'Destinatario' label = 'Destinatario' type = 'text' />
                </div>
                <div style={{display: 'flex', justifyContent: 'start'}}>
                    <button className="button w-auto" onClick={handleOpenWarning}>Filtrar</button>
                </div>
            </BasicCardDocumentos>
            </div>
        </>
    );
}